import * as actionTypes from "./actionTypes";

export const setStep = (payload) => {
  return {
    type: actionTypes.SET_STEP,
    payload: payload,
  };
};
